// extracted by mini-css-extract-plugin
export default {"inputGroup":"CoordinatesInput_inputGroup__iTzUF","inputContainer":"CoordinatesInput_inputContainer__rFNV9","input":"CoordinatesInput_input__4T299"};